module.exports = __webpack_public_path__ + "media/Audio17_p.c41896bd.wav";